import { z } from "zod";
// What has been entered for one field: text, a number, a checked state, or the
// values of the options chosen.
export const FieldValueSchema = z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.array(z.string()),
]);
/**
 * An answer's key: `<moduleId>.<fieldId>`.
 *
 * The first GUID is the form module's id (`form_modules.id`) — the reusable
 * section the field sits in, not the template's id. The template a note is
 * written from is named once on the note as `templateId`, so the same module
 * keys the same answers whichever template holds it. The second GUID is the
 * field's id within that module's definition, minted when the field is added
 * in the builder and kept through relabelling, so an answer stays with its
 * field through a rename, and two modules' fields never share a key.
 *
 * A template-literal schema, so the inferred key type also demands both
 * halves: a bare field id cannot index a note's answers.
 */
export const AnswerKeySchema = z.templateLiteral([z.guid(), ".", z.guid()], {
    error: "Expected <moduleId>.<fieldId>",
});
/** The key a module's field is answered under: the one place it is spelled. */
export const answerKeyOf = (moduleId, fieldId) => `${moduleId}.${fieldId}`;
/**
 * The answers a form sends to be saved: null for a field cleared, which is
 * then kept as no answer. A field bound to a record is written back to it, so
 * a clear is said rather than left out.
 */
export const SentAnswersSchema = z.record(AnswerKeySchema, FieldValueSchema.nullable());
